"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTable = SimpleTable;
var react_1 = __importStar(require("react"));
var themes_1 = require("../../themes");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var BlockLabel_1 = require("../../v2/components/BlockLabel");
//local utils
var styled_components_1 = require("styled-components");
var utilsOolib_1 = require("../../utilsOolib");
var AddRowColButtons_1 = require("./comps/AddRowColButtons");
var UIContent_1 = require("../../UIContent");
var ActionMenu_1 = require("../ActionMenu");
var ColActionsMenu_1 = require("./comps/rowColActionMenus/ColActionsMenu");
var RowActionsMenu_1 = require("./comps/rowColActionMenus/RowActionsMenu");
var handleColActions_1 = require("./handlers/handleColActions");
var handleRowActions_1 = require("./handlers/handleRowActions");
var handleStretchToFullWidth_1 = require("./handlers/handleStretchToFullWidth");
var handleToggleRowHeader_1 = require("./handlers/handleToggleRowHeader");
var handleToggleColHeader_1 = require("./handlers/handleToggleColHeader");
var styled_1 = require("./styled");
var useResizeTableColumns_1 = require("./useResizeTableColumns");
var convertColHeaderConfigToRowData_1 = require("./utils/convertColHeaderConfigToRowData");
var convertRowHeaderConfigToCellData_1 = require("./utils/convertRowHeaderConfigToCellData");
var prepInitValueFromConfigIfNoValue_1 = require("./utils/prepInitValueFromConfigIfNoValue");
var DropdownSingle_1 = require("../Dropdowns/DropdownSingle");
var TextInputs_1 = require("../TextInputs");
var icons_1 = require("../../icons");
var Typo2_1 = require("../../v2/components/Typo2");
var ArrowDown = icons_1.icons.ArrowDown;
var greyColor100 = themes_1.colors.greyColor100;
/**
 * PENDINGS
 * - Ideally should migrate RichTextEditor to Lexical
 * - Should run a function that converts rich text to plain text and sends that out in onChange. (like how we do for TitleInput)
 * - for backwards compatibility, in the initValueSetting function, we should convert all plain text values to lexical shape & all draftjs shaped values also to lexical shape
 * - memoization of cell comps maybe? there is some commented code for the same below..
 * - KNOWN ISSUE: when the number input block is used, the component is lagging like mad. might have something to
 *   do with the memoization issue
 */
function SimpleTable(_a) {
    var id = _a.id, readOnly = _a.readOnly, _b = _a.config, config = _b === void 0 ? {
        noOfCols: 3,
        noOfRows: 3,
        headerForRowHeadersColumn: undefined,
        colHeaderData: undefined,
        rowHeaderData: undefined,
        disableAddRow: false,
        disableRowActionsMenu: false,
        blockConfig: [undefined, { comp: 'DropdownSingle', props: {} }, { comp: 'DropdownSingle', props: {} }]
    } : _b, _value = _a.value, onChange = _a.onChange, _c = _a.defaultColWidth, defaultColWidth = _c === void 0 ? 200 : _c;
    var props = arguments[0];
    var theme = (0, styled_components_1.useTheme)();
    var _d = theme || {}, RichTextEditor = _d.RichTextEditor /*: _RichTextEditor*/, convertToRichText = _d.convertToRichText;
    //memoizing cuz we dont want all cell rtes to render everytime one cell changes
    // const RichTextEditor = useMemo(() => {
    //   const checkMemoFn = (prevProps, currentProps) => {
    //     const {
    //       value: prevVal,
    //     } = prevProps
    //     const {
    //       value: currentVal
    //     } = currentProps
    //     return isEqual(prevVal, currentVal)
    //   }
    //   return _RichTextEditor && React.memo(_RichTextEditor, checkMemoFn)
    // },[])
    var _e = (0, react_1.useMemo)(function () {
        return (0, prepInitValueFromConfigIfNoValue_1.prepInitValueFromConfigIfNoValue)({
            //memo v.imp cuz otherwise cell and row id keep changing on rerender if value doesnt exist, and this messes with their react keys, this leads to bugs
            _value: _value,
            config: config,
            defaultColWidth: defaultColWidth,
        });
    }, [_value]), value = _e.value, enableColActions = _e.enableColActions, //returns all possible actions config if no config.colHeaderData is defined. else undefined\
    enableRowActions = _e.enableRowActions;
    var _f = (0, useResizeTableColumns_1.useResizeTableColumns)({
        setColWidthConfig: function (setterFn) {
            var newColWidthConfig = setterFn(value.colWidthConfig);
            onChange(id, __assign(__assign({}, value), { colWidthConfig: newColWidthConfig }));
        }, // here we are replicating the setState(prev => do something) behaviour
        colWidthConfig: value.colWidthConfig,
        theme: theme,
    }), resetColResizeState = _f.resetColResizeState, hideShowDragZoneIndicator = _f.hideShowDragZoneIndicator, initColResizeState = _f.initColResizeState, resetDragZoneIndicator = _f.resetDragZoneIndicator, handleResizeColumn = _f.handleResizeColumn, colResizeState = _f.colResizeState, dragZoneWidth = _f.dragZoneWidth;
    (0, react_1.useEffect)(function () {
        window.addEventListener("mouseup", resetColResizeState);
        window.addEventListener("mousemove", handleResizeColumn);
        return function () {
            window.removeEventListener("mousemove", handleResizeColumn);
            window.removeEventListener("mouseup", resetColResizeState);
        };
    }, [colResizeState]);
    var CellContentBlocks = {
        RichTextEditor: RichTextEditor,
        DropdownSingle: DropdownSingle_1.DropdownSingle,
        NumberInput: TextInputs_1.NumberInput,
    };
    var CellContentBlockDefaultProps = {
        RichTextEditor: {
            variant: "simple",
            typo: "SANS_3",
            placeholder: " ",
            style: {
                padding: "0.9rem 1rem",
            },
        },
        DropdownSingle: {
            selectStyleOverride: {
                backgroundColor: themes_1.colors.none,
            },
            popOutOfOverflowHiddenParent: true,
        },
        NumberInput: {
            selectStyleOverride: {
                backgroundColor: themes_1.colors.none,
            },
        }
    };
    var CellValueGetters = {
        RichTextEditor: function (v) { return (convertToRichText ? convertToRichText(v) : v); },
    }; //prob dont need this..
    var _g = (0, react_1.useState)(undefined), actionsActiveOnRow = _g[0], setActionsActiveOnRow = _g[1];
    var _h = (0, react_1.useState)(undefined), actionsActiveOnCol = _h[0], setActionsActiveOnCol = _h[1];
    var _j = (0, react_1.useState)({
        rowIdx: undefined,
        colIdx: undefined,
    }), hoveredRowAndCol = _j[0], setHoveredRowAndCol = _j[1];
    var handleCellInputChange = function (_a) {
        var cellIdx = _a.cellIdx, rowIdx = _a.rowIdx, v = _a.v;
        var valData = value.data;
        var colWidthConfig = value.colWidthConfig;
        var newData = __spreadArray([], valData, true);
        newData[rowIdx].cellData[cellIdx].value = v;
        onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
    };
    /**
     * we are explicitly defining this here and passing it on to AddColButton comp
     * since we need this width to calculate stretch to full width
     */
    var addColButtonWidth = 20;
    // these are explicitly defined here cuz we need to calc offset padding and margin using these, so that overflowX doesnt hide them
    var rowActionsButtonWidth = 15;
    var colActionsButtonHeight = 15;
    var primaryTableActionsMenuHeight = 30;
    var primaryTableActionsMenuGap = 5;
    var genCell = function (_a) {
        var cell = _a.cell, cellIdx = _a.cellIdx, rowIdx = _a.rowIdx, _b = _a.enableColResizeActions // cuz in the case of pre fixed column (via config.rowHeaderData), enableResize will be set to false
        , enableColResizeActions = _b === void 0 ? true : _b // cuz in the case of pre fixed column (via config.rowHeaderData), enableResize will be set to false
        ;
        var cellCompName = cell.comp || 'RichTextEditor';
        var NoCompPlaceholder = function () { return react_1.default.createElement("div", null, "No comp exists"); };
        var CellComp = CellContentBlocks[cellCompName] || NoCompPlaceholder;
        var cellProps = CellContentBlockDefaultProps[cellCompName] ? __assign(__assign({}, CellContentBlockDefaultProps[cellCompName]), (cell.props || {})) : {};
        var cellValue = CellValueGetters[cellCompName] ? CellValueGetters[cellCompName](cell.value) : cell.value;
        var cellWidth = value.colWidthConfig["col_".concat(cellIdx)] || defaultColWidth + 'px'; //cuz when pre-fixed column is applied via config.rowHeaderData, no colWidthConfig will be there for it in value.colWidthConfig
        //(100% - totalExplicitWidths)/(totalColumns - noOfColsWithExplicitWidths)
        // let cellProps = {
        // 	...CellContentBlockDefaultProps[cell.comp],
        // 	...(cell.props ? cell.props : {}),
        // }
        if (cell.isRowHeader)
            console.log({ cell: cell });
        var StyledCellWrapper = cell.isRowHeader
            ? styled_1.StyledSimpleTableHeaderCell
            : styled_1.StyledSimpleTableCell;
        return (react_1.default.createElement(StyledCellWrapper, __assign({ key: cell.id, id: "kp_table__cell__".concat(cell.id), readOnly: readOnly || cell.readOnly, style: {
                color: greyColor100,
                width: "".concat(cellWidth),
                borderRight: (colResizeState === null || colResizeState === void 0 ? void 0 : colResizeState.colId) === "col_".concat(cellIdx) &&
                    "2px solid ".concat((0, utilsOolib_1.getPrimaryColor100)(theme === null || theme === void 0 ? void 0 : theme.colors)),
            }, actionsActiveOnRow: actionsActiveOnRow, colIdx: cellIdx, rowIdx: rowIdx, totRows: value.data.length, actionsActiveOnCol: actionsActiveOnCol }, (enableColResizeActions
            ? {
                onMouseEnter: function (e) {
                    setHoveredRowAndCol({
                        rowIdx: rowIdx,
                        colIdx: cellIdx,
                    });
                },
                onMouseDown: function (e) {
                    initColResizeState(e, { colId: "col_".concat(cellIdx) });
                },
                onMouseOut: function (e) { return resetDragZoneIndicator(__assign({ e: e }, (cell.isRowHeader ? { borderStyleInactive: "2px solid ".concat(themes_1.colors.greyColor10) } : {}))); },
                onMouseMove: function (e) { return hideShowDragZoneIndicator(__assign({ e: e }, (cell.isRowHeader ? {
                    borderStyleInactive: "2px solid ".concat(themes_1.colors.greyColor10),
                    borderStyleActive: "2px solid ".concat((0, utilsOolib_1.getPrimaryColor100)(theme === null || theme === void 0 ? void 0 : theme.colors))
                } : {}))); }
            } : {}), { tabIndex: 0 }),
            react_1.default.createElement(ColActionsMenu_1.ColActionsMenu, { value: value, colIdx: cellIdx, onChange: onChange, id: id, defaultColWidth: defaultColWidth, setActionsActiveOnCol: setActionsActiveOnCol, colActionsButtonHeight: colActionsButtonHeight, conditionsToRender: !readOnly &&
                    enableColActions &&
                    rowIdx === 0 &&
                    hoveredRowAndCol.colIdx === cellIdx }),
            !config.disableRowActionsMenu && react_1.default.createElement(RowActionsMenu_1.RowActionsMenu, { value: value, rowIdx: rowIdx, onChange: onChange, id: id, setActionsActiveOnRow: setActionsActiveOnRow, rowActionsButtonWidth: rowActionsButtonWidth, disableAddRow: config === null || config === void 0 ? void 0 : config.disableAddRow,
                conditionsToRender: !readOnly &&
                    enableRowActions &&
                    cellIdx === 0 &&
                    rowIdx !== undefined && //cuz for fixed col headers, rowIdx is undefined
                    hoveredRowAndCol.rowIdx === rowIdx }),
            react_1.default.createElement("div", { style: { marginRight: dragZoneWidth + "px" } },
                react_1.default.createElement(CellComp, __assign({}, cellProps, { id: "kp_table_cell__".concat(cell.id, "__rich_input") /*dont mess with this id nomenclature. it needs to stay this way. check out the handleCellInputChange fn to understand */, value: cellValue, readOnly: readOnly || cell.readOnly, onChange: function (k, v) {
                        return handleCellInputChange({ v: v, rowIdx: rowIdx, cellIdx: cellIdx });
                    } })))));
    };
    var genRow = function (_a) {
        var row = _a.row, rowIdx = _a.rowIdx;
        var StyledWrapper = row.isColHeader
            ? styled_1.StyledSimpleTableHeader
            : styled_1.StyledSimpleTableRow;
        // const NoCompPlaceholder = () => <div>No comp exists</div>;
        // let CellCompNameForHeaderForRowHeadersColumn = CellContentBlocks["RichTextEditor"] || NoCompPlaceholder
        return (react_1.default.createElement(StyledWrapper, { actionsActiveOnRow: actionsActiveOnRow, 
            // onClick={() => row.link && history.push(row.link)}
            style: { display: "flex" }, readOnly: readOnly, rowIdx: rowIdx, key: row.id },
            config.rowHeaderData && (row.isColHeader && config.headerForRowHeadersColumn !== undefined ? (react_1.default.createElement(styled_1.StyledSimpleTableHeaderCell, { key: "cornerHeaderCell", id: "kp_table__cell__cornerHeaderCell", readOnly: true, style: {
                    color: greyColor100,
                    width: value.colWidthConfig["col_corner"] || defaultColWidth + 'px',
                } },
                react_1.default.createElement("div", { style: { display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.9rem 1rem" } },
                    react_1.default.createElement(Typo2_1.UI_BODY_BOLD_SM, null, config.headerForRowHeadersColumn),
                    react_1.default.createElement(ArrowDown, { size: 14, weight: "bold" })))) : (genCell({
                cell: (0, convertRowHeaderConfigToCellData_1.convertRowHeaderConfigToCellData)({
                    rowHeaderData: config.rowHeaderData,
                    convertToRichText: convertToRichText,
                    rowIdx: rowIdx
                }),
                enableColResizeActions: false
            }))),
            row.cellData.map(function (cell, cellIdx) { return genCell({ cell: cell, cellIdx: cellIdx, rowIdx: rowIdx }); })));
    };
    var fullWidthCompWrapper = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement("div", { style: {
                overflowX: "auto",
                paddingLeft: rowActionsButtonWidth / 2 + "px",
                marginLeft: "-" + rowActionsButtonWidth / 2 + "px",
                paddingTop: primaryTableActionsMenuGap + primaryTableActionsMenuHeight + "px",
            } },
            react_1.default.createElement("div", { ref: fullWidthCompWrapper, style: {
                    display: "flex",
                    alignItems: "stretch" /**without stretch AddColButton will be wonky */,
                } },
                react_1.default.createElement("div", { style: { position: "relative" } },
                    react_1.default.createElement("div", { style: {
                            position: "absolute",
                            right: 0,
                            top: "-" + primaryTableActionsMenuGap + "px",
                            transform: "translateY(-100%)",
                            zIndex: 10,
                        } },
                        react_1.default.createElement(ActionMenu_1.ActionMenu, { ButtonComp: "ButtonPrimary", actions: __spreadArray(__spreadArray([
                                {
                                    display: UIContent_1.UIContent.SimpleTable.stretchToFullWidth,
                                    onClick: function () {
                                        return (0, handleStretchToFullWidth_1.handleStretchToFullWidth)({
                                            value: value,
                                            onChange: onChange,
                                            id: id,
                                            enableColActions: enableColActions,
                                            addColButtonWidth: addColButtonWidth,
                                            fullWidthCompWrapper: fullWidthCompWrapper,
                                        });
                                    },
                                }
                            ], (enableRowActions
                                ? [
                                    {
                                        icon: "SquareHalf",
                                        display: value.data[0].cellData[0].isRowHeader
                                            ? UIContent_1.UIContent.SimpleTable.removeHeaderCol
                                            : UIContent_1.UIContent.SimpleTable.addHeaderCol,
                                        onClick: function () { return (0, handleToggleColHeader_1.handleToggleColHeader)({ value: value, onChange: onChange, id: id }); },
                                    },
                                ]
                                : []), true), (enableColActions
                                ? [
                                    {
                                        icon: "SquareHalfBottom",
                                        display: value.data[0].isColHeader
                                            ? UIContent_1.UIContent.SimpleTable.removeHeaderRow
                                            : UIContent_1.UIContent.SimpleTable.addHeaderRow,
                                        onClick: function () {
                                            return (0, handleToggleRowHeader_1.handleToggleRowHeader)({ value: value, onChange: onChange, id: id });
                                        },
                                    },
                                ]
                                : []), true) })),
                    react_1.default.createElement(styled_1.StyledSimpleTable, { onMouseLeave: function () {
                            return setHoveredRowAndCol({ rowIdx: undefined, colIdx: undefined });
                        } },
                        config.colHeaderData &&
                            genRow({
                                row: (0, convertColHeaderConfigToRowData_1.convertColHeaderConfigToRowData)({
                                    colHeaderData: config.colHeaderData,
                                    convertToRichText: convertToRichText,
                                }),
                            }),
                        value.data.map(function (row, rowIdx) { return genRow({ row: row, rowIdx: rowIdx }); })),
                    !readOnly && enableRowActions && !config.disableAddRow && (react_1.default.createElement(AddRowColButtons_1.AddRowButton, { onClick: function () { return (0, handleRowActions_1.handleAddRow)(value, props); } }))),
                !readOnly && enableColActions && (react_1.default.createElement(AddRowColButtons_1.AddColButton, { enableRowActions: enableRowActions, addColButtonWidth: addColButtonWidth, onClick: function () {
                        return (0, handleColActions_1.handleAddCol)({ value: value, onChange: onChange, id: id, defaultColWidth: defaultColWidth });
                    } }))))));
}
